import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/modals'
// components
import { IconButton } from 'components/UI'
// static
import SettingsIconOrigin from '@mui/icons-material/Settings'
// themes
import colors from 'themes/colors'

const SettingsIcon = styled(SettingsIconOrigin)`
  && {
    path {
      fill: ${colors.white};
    }
  }
`

const TemplateSettingsButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.RISK_TEMPLATE_SETTINGS_MODAL })

  const showSettings = () => showModal()

  return (
    <IconButton data-testid='open-template-settings' onClick={showSettings} description='Template Settings'>
      <SettingsIcon />
    </IconButton>
  )
}

export default TemplateSettingsButton
